/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	export class Dem {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(csv:string) {
			this.isAvailable = true;

			this.elevations = [];
			this.minElevation = Number.MAX_VALUE;
			this.maxElevation = -Number.MAX_VALUE;
			const lines:string[] = csv.split('\n');
			const lineCount:number = lines.length;
			let line:string;
			let elements:string[];
			let element:string;
			let elementCount:number;
			let elevation:number;
			for (let i:number = 0; i < lineCount; ++i) {
				line = lines[i];
				if (line != '') {
					elements = lines[i].split(',');
					elementCount = elements.length;
					for (let j:number = 0; j < elementCount; ++j) {
						element = elements[j];
						if (element == 'e') {
							this.elevations.push(NaN);
						} else {
							elevation = parseFloat(element);
							if (elevation < this.minElevation) this.minElevation = elevation;
							if (elevation > this.maxElevation) this.maxElevation = elevation;
							this.elevations.push(elevation);
						}
					}
				}
			}

			//trace('[Dem] raw :', csv);
			trace('[Dem]', this);
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public getIsAvailable():boolean {
			return this.isAvailable;
		}

		public getElevations():number[] {
			return this.elevations;
		}

		public getMinElevation():number {
			return this.minElevation;
		}

		public getMaxElevation():number {
			return this.maxElevation;
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private isAvailable:boolean;

		private elevations:number[];

		private minElevation:number;
		private maxElevation:number;
	}
}
